var exports = {
  "AS": "x4ddf2309--a16e97--item",
  "$_": "x4ddf2309--a16e97--media",
  "iW": "x4ddf2309--a16e97--main",
  "B7": "x4ddf2309--a16e97--info-container",
  "pq": "x4ddf2309--a16e97--info",
  "Yg": "x4ddf2309--a16e97--village-link",
  "cL": "x4ddf2309--a16e97--builder",
  "sx": "x4ddf2309--a16e97--builder-name",
  "q2": "x4ddf2309--a16e97--builder-image",
  "fI": "x4ddf2309--a16e97--builder-description",
  "SU": "x4ddf2309--a16e97--village_objects",
  "Qk": "x4ddf2309--a16e97--village-info",
  "hX": "x4ddf2309--a16e97--commute",
  "NJ": "x4ddf2309--a16e97--commute-icon",
  "Cl": "x4ddf2309--a16e97--objects-link",
  "HA": "x4ddf2309--a16e97--builder-name-link",
  "Cp": "x4ddf2309--a16e97--address-link",
  "q_": "x4ddf2309--a16e97--title-link",
  "WD": "x4ddf2309--a16e97--labels",
};

module.exports = exports;
